<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />

    <b-card>
      <search-input
        placeholder="أدخل اسم الصفحة أو جزء منه ..."
        v-model="search"
        class="w-25"
      />
      <data-table
        @row-clicked="onRowCLicked"
        hover
        ep="v2/ministry/instructions"
        :fields="fields"
        :pagination="false"
        :hidePageSize="false"
        ref="instructionsTable"
      />
    </b-card>
  </div>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import DataTable from "@/components/data-table/index.vue";
import SearchInput from "@/components/SearchInput.vue";
import debounce from "lodash.debounce";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    MinistryBreadcrumbs,
    DataTable,
    SearchInput,
  },

  data() {
    return {
      mainTitle: "الإرشادات",
      search: "",
      fields: [
        {
          label: "المعرف",
          key: "id",
        },
        {
          label: "اسم الصفحة",
          key: "name",
        },
      ],
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الإرشادات",
          active: true,
        },
      ],
    };
  },
  watch: {
    search: debounce(function (val) {
      this.$refs.instructionsTable.setQueryParams({ name: val });
      this.$refs.instructionsTable.refreshTable();
    }, 500),
  },
  methods: {
    onRowCLicked({ id }) {
      this.$router.push({ name: "settings-instructions-show", params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped></style>
